export default __webpack_public_path__ + "static/media/2.0a2e637a.svg";